/**
 * routes.ts — canonical route path constants for the portal.
 *
 * Import these instead of hard-coding strings so route renames propagate
 * automatically to all link/navigate call-sites.
 */

export const ROUTES = {
  aiAssistants: "/ai-assistants",
  root:                    "/",
  collections:             "/collections",
  collectionsDetail:       "/collections/details/:obligorId",
  revenueForecastingRoot:  "/revenue-forecasting",
  fraud:                   "/fraud",
  settings:                "/settings",
  settingsAssistants:      "/settings/assistants",
  settingsKnowledgeBase:       "/settings/knowledge-base",
  settingsKnowledgeBaseDetail: "/settings/knowledge-base/:id",
  settingsPermissions:     "/settings/permissions",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
